import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DeliveryCmsComponents } from '@core/const';
import {
  CustomGenericLinkComponent,
  FormFieldNewComponent,
  OnlyNumberDirective,
  SdvorButtonComponent,
  SdvorSelectModule,
} from '@sdvor/shared/ui';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { FormErrorsComponent, IconModule } from '@spartacus/storefront';
import { DeliveryCalculatorFormComponent } from './delivery-calculator-form.component';

@NgModule({
  declarations: [DeliveryCalculatorFormComponent],
  imports: [
    AsyncPipe,
    IconModule,
    FormFieldNewComponent,
    CustomGenericLinkComponent,
    FormErrorsComponent,
    ReactiveFormsModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [DeliveryCmsComponents.SdCMSDeliveryCalculatorFormComponent]: { component: DeliveryCalculatorFormComponent },
      },
    }),
    SdvorSelectModule,
    SdvorButtonComponent,
    OnlyNumberDirective,
  ],
})
export class DeliveryCalculatorFormModule {}
